import { Box, Tag } from '@factorialco/deprecated-design-system'
import {
  TimeTrackingClockInDayRowWorkedBreaksFragment,
  TimesheetPageEmployeesSettingFragment,
} from 'generated/resources/graphql'
import { TimesheetEstimatedTimeFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { observer } from 'mobx-react'

import type Store from 'modules/attendance/components/ClockIn/Store'
import { shouldGreyOut } from 'modules/attendance/lib/dayRowStyle'
import type CalendarDay from 'modules/attendance/store/models/CalendarDay'

import { EstimatedHours } from './EstimatedHours'
import { WorkedHours } from './WorkedHours'

interface Props {
  date: moment.Moment
  store: Store
  calendarDay: CalendarDay
  hasUnresolvedShift?: boolean
  workedBreaks: TimeTrackingClockInDayRowWorkedBreaksFragment[]
  balanceAmount: string | undefined
  attendanceSetting: TimesheetPageEmployeesSettingFragment
  estimatedTime: TimesheetEstimatedTimeFragment
  trackedMinutes: number
  workedMinutes: number
  workedMinutesNotApproved: number
  breaksMinutesRounded: number
  hasCorrectiveBreaks: boolean
  hasExtraHourManagementV2: boolean
  hasTimeTrackingInconsistencies: boolean
}

const DurationColumn = ({
  date,
  store,
  calendarDay,
  workedBreaks,
  hasUnresolvedShift,
  balanceAmount,
  attendanceSetting,
  estimatedTime,
  trackedMinutes,
  workedMinutes,
  workedMinutesNotApproved,
  breaksMinutesRounded,
  hasCorrectiveBreaks,
  hasExtraHourManagementV2,
  hasTimeTrackingInconsistencies,
}: Props) => {
  const { is_laborable, is_leave } = calendarDay.attributes
  const isGrayedOut = shouldGreyOut({
    worked: workedMinutes,
    is_leave,
    is_laborable,
  })
  const grayedOutColor = isGrayedOut ? 'grey700' : 'grey800'

  return (
    <Box
      flexDirection="row"
      gap="s8"
      alignItems="center"
      paddingX="s24"
      width="fit-content"
      border={{ left: { width: 's1', style: 'solid', color: 'grey400' } }}
      extra={{ 'data-intercom-target': 'attendance-row-duration-column' }}
    >
      <WorkedHours
        date={date}
        store={store}
        worked={workedMinutes}
        trackedMinutes={trackedMinutes}
        workedMinutesNotApproved={workedMinutesNotApproved}
        workedBreaks={workedBreaks}
        breaksMinutesRounded={breaksMinutesRounded}
        hasCorrectiveBreaks={hasCorrectiveBreaks}
        grayedOutColor={grayedOutColor}
        hasUnresolvedShift={!!hasUnresolvedShift}
        attendanceSetting={attendanceSetting}
        hasTimeTrackingInconsistencies={hasTimeTrackingInconsistencies}
      />
      /
      <EstimatedHours
        date={date}
        store={store}
        grayedOutColor={grayedOutColor}
        estimatedTime={estimatedTime}
      />
      {!hasExtraHourManagementV2 && !!balanceAmount && (
        <Box width="fit-content">
          <Tag type={Tag.Types.grey}>{balanceAmount}</Tag>
        </Box>
      )}
    </Box>
  )
}

export default observer(DurationColumn)
